import { isBefore, startOfDay } from '@sequencehq/utils/dates'

/**
 * Today as billing counts it. Billing counts days in UTC, and so does
 * `startOfDay`, so this is the UTC date rather than the browser's.
 */
export const getBillingToday = () => startOfDay(new Date())

/**
 * Whether the date an amendment takes effect is before today. Billing can't
 * change a schedule in the past, so it won't publish one like that, and
 * executes one only from today.
 */
export const hasAmendmentDatePassed = ({
  effectiveFrom,
  today
}: {
  effectiveFrom: Date
  today: Date
}) => isBefore(startOfDay(effectiveFrom), today)
